import React from 'react'

const DashBoardsCards = ({ data }) => {
  return (
    <div className="bg-white border border-gray-200 shadow-sm hover:shadow-md transition-shadow rounded-lg p-2 md:p-3 w-full flex flex-col justify-center items-start">
      <p 
        className="text-[10px] md:text-xs text-gray-500 font-semibold uppercase tracking-wider mb-1 break-words w-full leading-snug"
        title={data.title}
      >
        {data.title}
      </p>
      <h1 className="text-lg md:text-xl font-bold text-gray-900 leading-none">
        {data.count}
      </h1>
    </div>
  )
}

export default DashBoardsCards